module.exports = __webpack_public_path__ + "img/logo.40375270.svg";